module.exports = __webpack_public_path__ + "img/005-hands.4ff03c34.png";